<script>
import MottoIcon from '@components/motto-icon.vue'

export default {
  components: {
    MottoIcon,
  },
  props: {
    categoryName: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      isHover: false,
    }
  },
  computed: {
    getCategoryIcon() {
      const categoryIcons = {
        'Office Setup': 'Resources',
        Brand: 'Bag',
        Technology: 'Tool',
        'Tech Access': 'Link',
        Compliance: 'Briefcase',
        Education: 'GraduationCap',
        Industry: 'Home',
      }
      return categoryIcons[this.categoryName]
    },
  },
}
</script>

<template>
  <div
    :class="{ [$style.categoryIconContainer]: true, [$style.active]: active }"
    data-category-icon
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
    @touchend="isHover = false">
    <MottoIcon :class="$style.categoryIcon" :name="getCategoryIcon" icon-color="white"></MottoIcon>
    <div :class="{ [$style.bottomLayer]: true, [$style.active]: active }">
      <p class="overline-text">{{ categoryName }}</p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.categoryIconContainer {
  display: flex;
  flex-direction: column;
  min-width: 138px;
  max-width: 138px;
  color: $light-gray;
  cursor: pointer;
  user-select: none;
  background: $primary-blue;
  border: 1px solid currentColor;
  border-radius: 8px;

  p {
    color: $dark-gray;
    white-space: nowrap;
  }

  &.active {
    color: $secondary-green;
    background: $secondary-green;
  }

  &:hover {
    @media (min-width: $lg-breakpoint) {
      color: $secondary-green;
      background: $secondary-green;
    }
  }
}

.categoryIcon {
  height: 32px;
  margin: 12px auto;

  svg {
    width: 32px;
    height: 32px;
  }

  svg[data-icon='graduation-cap'] {
    width: 40px;
  }

  svg[data-icon='link'] {
    width: 26px;
  }
}

.bottomLayer {
  padding: 11px 32px;
  text-align: center;
  background: $white;
  border-top: 1px solid currentColor;
  border-radius: 0 0 6px 6px;
}
</style>
